import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Typography, Box, CircularProgress, Grid, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { ArrowBack, Menu, ArrowForward } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material'; // Thêm import này

const ChapterDetails = () => {
    const { chapterId } = useParams(); // Lấy chapterId từ URL
    const navigate = useNavigate(); // Sử dụng useNavigate để điều hướng
    const [chapterData, setChapterData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [comicChapters, setComicChapters] = useState([]); // State để lưu danh sách chương
    const [comicId, setComicId] = useState(null); // State để lưu comicId
    const [openDialog, setOpenDialog] = useState(false); // State để mở dialog
    const [hoveredChapter, setHoveredChapter] = useState(null); // State để lưu chapter đang hover

    const isMobile = useMediaQuery('(max-width: 750px)'); // Kiểm tra nếu màn hình nhỏ hơn 560px

    // Lấy dữ liệu chương từ API
    const fetchChapterDetails = async () => {
        try {
            const response = await axios.get(`https://sv1.otruyencdn.com/v1/api/chapter/${chapterId}`); // Lấy dữ liệu từ API
            console.log('Chapter Data:', response.data); // In dữ liệu trả về từ API
            setChapterData(response.data.data.item); // Lưu item vào state
            const urlParams = new URLSearchParams(window.location.search);
            setComicId(urlParams.get('comicId')); // Lấy comicId từ query string
        } catch (error) {
            console.error('Error fetching chapter details:', error);
            setError('Không thể tải nội dung chương.');
        } finally {
            setLoading(false);
        }
    };

    // Lấy danh sách chương
    const fetchComicChapters = async () => {
        if (comicId) {
            try {
                const response = await axios.get(`https://otruyenapi.com/v1/api/truyen-tranh/${comicId}`); // Lấy dữ liệu truyện
                setComicChapters(response.data.data.item.chapters); // Lưu danh sách chương vào state
            } catch (error) {
                console.error('Error fetching comic chapters:', error);
                setError('Không thể tải danh sách chương.');
            }
        }
    };

    useEffect(() => {
        fetchChapterDetails(); // Gọi hàm lấy dữ liệu chương
        window.scrollTo(0, 0);
    }, [chapterId]);

    useEffect(() => {
        if (comicId) {
            fetchComicChapters(); // Gọi hàm lấy danh sách chương khi comicId thay đổi
        }
    }, [comicId]);

    // Nếu đang loading
    if (loading) {
        return (
            <Container className="app-container">
                <CircularProgress />
            </Container>
        );
    }

    if (error) {
        return <Typography>{error}</Typography>;
    }

    // Kiểm tra chapterData trước khi sử dụng
    if (!chapterData) {
        return <Typography>Không tìm thấy nội dung chương.</Typography>;
    }

    return (
        <Container className="app-container">
            <Box textAlign="center" mb={2}> {/* Căn giữa tiêu đề */}
                <Typography variant={isMobile ? 'h5' : 'h4'} gutterBottom>
                    {chapterData.comic_name}
                </Typography>
                <Typography variant={isMobile ? 'h6' : 'h5'}>
                    Chương {chapterData.chapter_name}: {chapterData.chapter_title}
                </Typography>
            </Box>
            <hr style={{ margin: '20px 0' }} /> {/* Hàng ngang với khoảng cách */}
            <Box mt={2}>
                <Grid container spacing={2}>
                    {chapterData.chapter_image.map((image, index) => (
                        <Grid item xs={12} key={index}>
                            <img
                                src={`https://sv1.otruyencdn.com/${chapterData.chapter_path}/${image.image_file}`} // Đường dẫn tới hình ảnh
                                alt={`Page ${image.image_page}`}
                                style={{ width: '80%', height: 'auto', marginBottom: '10px', display: 'block', margin: '0 auto' }} // Giảm kích thước và căn giữa
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* Các button cố định bên phải */}
            <Box position="fixed" right={20} bottom={20} display="flex" flexDirection="column" alignItems="flex-end">
                <IconButton color="primary" onClick={() => setOpenDialog(true)} aria-label="Menu">
                    <Menu />
                </IconButton>
            </Box>

            {/* Dialog hiển thị danh sách chương */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} aria-labelledby="chapter-list-dialog-title">
                <DialogTitle id="chapter-list-dialog-title">Danh Sách Chương</DialogTitle>
                <DialogContent dividers>
                    <Box maxHeight="300px" overflow="auto">
                        {comicChapters.slice(0, 6).map((chapter, index) => (
                            chapter.server_data.map(serverChapter => (
                                <Typography 
                                    key={serverChapter.chapter_api_data} 
                                    style={{ 
                                        cursor: 'pointer', 
                                        margin: '5px 0', 
                                        backgroundColor: hoveredChapter === serverChapter.chapter_api_data ? '#f0f0f0' : 'transparent', // Hiệu ứng hover
                                        padding: '5px' // Thêm padding
                                    }} 
                                    onMouseEnter={() => setHoveredChapter(serverChapter.chapter_api_data)} // Khi di chuột vào
                                    onMouseLeave={() => setHoveredChapter(null)} // Khi rời chuột ra
                                    onClick={() => {
                                        setLoading(true); // Bắt đầu loading
                                        setOpenDialog(false); // Đóng dialog
                                        window.scrollTo(0, 0); // Cuộn về đầu trang
                                        navigate(`/chapters/${serverChapter.chapter_api_data.split('/').pop()}?comicId=${comicId}`); // Chuyển đến chương đã chọn
                                    }}
                                >
                                    Chương {serverChapter.chapter_name}: {serverChapter.chapter_title || 'Chưa có tiêu đề'}
                                </Typography>
                            ))
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        Đóng
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default ChapterDetails;
